<template>
  <div style="padding:20px 0;">
    <div class="notidetail_outer">
      <div class="notidetail_cont">
        <div class="head">
          <div class="tit" v-text="detail.post_title">
          </div>
          <div class="info">
            <span v-if="detail.level" v-text="'申报层级：'+detail.level"></span>
            <span v-if="detail.dept" v-text="'职能部门：'+detail.dept"></span>
            <span v-if="detail.end_time" v-text="'申报时限：'+detail.end_time"></span>
            <span v-if="detail.published_time" v-text="'发布时间：'+detail.published_time"></span>
          </div>
        </div>
        <div class="paragraph" v-html="detail.post_content"></div>
        <div class="additional">
          <div>附件</div>
          <div class="a_list" v-for="(item,index) in detail.files">
            <div class="item"><span v-text="index+1+'. '"></span>{{ item.name }}</div>
            <!--	<div class="item"><span>1. </span>奉贤区引进技术的吸收与创新计划项目申报表</div>
              <div class="item"><span>2. </span>奉贤区引进技术的吸收与创新计划项目申报文件袋</div>
              <div class="item"><span>3. </span>项目推荐函（由企业注册地所在主管部门填写）</div>
              <div class="item"><span>4. </span>申报说明</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.detail = {};
    let id = this.$route.query.id;
    this.id = id;
    console.log("id is ==>" + id)
    this.$ajax.get(this.bUrl + 'api/portal/articles/read?id=' + id)
      .then(function (res) {
        console.log('data is ', res.data.data)
        this.detail = res.data.data;
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },
  name: 'detail',
  data() {
    return {
      id: -1,
      detail: {
        post_title: "",
        published_time: "",
        post_content: "",
        level: "奉贤区级",
        dept: "人社局",
        end_time: "2020-08-29",
        files: [
          {
            url: "/upload/portal/20200828/e7bc5a7985c91de2be6089cbc6c6b782.zip",
            name: "msvcr120.zip"
          }
        ]
      },
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.notidetail_outer {
  background: #fff;
}

.notidetail_cont {
  width: 1180px;
  margin: 0 auto;
  padding: 66px;
  box-sizing: border-box;
  color: #666666;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  /*margin-top: 34px;*/
}

.notidetail_cont .head {
  text-align: center;
  margin-bottom: 20px;
}

.notidetail_cont .head .tit {
  font-size: 24px;
  color: #5F5F5F;
}

.notidetail_cont .head .info {
  padding: 0 150px;
  display: flex;
  justify-content: space-around;
  line-height: 40px;
  font-size: 12px;
  color: #666666;
}

.notidetail_cont .paragraph {
  margin: 0 90px;
}

.additional {
  background: #F0F5F8;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  padding: 28px;
  margin: 32px 24px 56px 24px;
  color: #143367;
}

.additional .a_list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 14px;
}

.additional .a_list .item {
  width: 40%;
  margin-right: 10%;
  line-height: 40px;
}

.btn_outer {
  text-align: center;
  font-size: 20px;
}

.btn_outer .ci_back {
  font-size: 24px;
  margin-left: 10px;
  display: inline-block;
  transform: rotate(180deg);
}

.btn_outer .ci_fav {
  margin-left: 10px;
  font-size: 30px;
}

.btm_tip {
  text-align: right;
  margin-right: 24px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/detail.vue